import * as THREE from 'three';

export type ShellHitEvent = {
  position: THREE.Vector3;
  radius: number;
  damage: number;
};

export class ArtilleryShell {
  readonly group: THREE.Group;
  readonly target: THREE.Vector3;
  active = true;

  private readonly velocity = new THREE.Vector3();
  private readonly gravity = 12;
  private readonly fallHeight = 16;

  constructor(
    target: THREE.Vector3,
    materials: { shell: THREE.Material; marker: THREE.Material },
    private readonly radius: number,
    private readonly damage: number,
  ) {
    this.target = target.clone();

    this.group = new THREE.Group();
    this.group.position.set(target.x, this.fallHeight, target.z);

    const body = new THREE.Mesh(new THREE.CylinderGeometry(0.06, 0.08, 0.35, 8), materials.shell);
    body.rotation.x = Math.PI / 2;
    body.castShadow = false;
    this.group.add(body);

    const marker = new THREE.Mesh(new THREE.RingGeometry(0.25, 0.35, 32), materials.marker);
    marker.rotation.x = -Math.PI / 2;
    marker.position.set(target.x, 0.06, target.z);
    this.group.add(marker);

    const timeToImpact = Math.sqrt((2 * this.fallHeight) / this.gravity);
    this.velocity.set(0, -this.fallHeight / timeToImpact, 0);
  }

  update(delta: number): ShellHitEvent | null {
    if (!this.active) return null;

    this.velocity.y -= this.gravity * delta;
    this.group.position.addScaledVector(this.velocity, delta);
    this.group.lookAt(this.target);

    if (this.group.position.y <= 0) {
      this.active = false;
      this.group.visible = false;
      return { position: new THREE.Vector3(this.target.x, 0, this.target.z), radius: this.radius, damage: this.damage };
    }

    return null;
  }

  dispose(): void {
    this.group.clear();
  }
}
